import axios from 'axios';
// import { Navigate } from 'react-router-dom';
import GlobalData from './globalData';

// setup axios instance

/* -------------------------------- Produzione -------------------------------- */
const BaseURL = 'https://api.hub.partitodemocratico.it/api';
// const BaseURL = 'https://api.partecipa.fourteentec.com/api';
/* ------------------------------- Sviluppo ------------------------------- */
// const BaseURL = 'https://api.dev.partecipa.fourteentec.com/api';
/* --------------------------------- Locale --------------------------------- */
// const BaseURL = process.env.BASE_URL || 'http://127.0.0.1:8000/api';

const API = axios.create({
  baseURL: BaseURL,
});

/**
 * Add a HTTP axios request interceptors
 */
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// let isRefreshing = false;
// const refreshAndRetryQueue = [];

/**
 * Add a HTTP axios response interceptors
 */
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // if token authorization error, refresh token and update previous token with new one
    if (
      error.response &&
      error.response.status === 401 &&
      // error.response.data.message === 'Unauthenticated.' &&
      originalRequest.url !== '/login' &&
      originalRequest.url !== '/passwordforgotten'
    ) {
      // if (!isRefreshing) {
      //   isRefreshing = true;

      //   try {
      //     const oldToken = localStorage.getItem('token');
      //     const axiosConfig = {
      //       headers: {
      //         Authorization: `Bearer ${oldToken}`,
      //         'Cache-Control': 'no-cache, no-store, must-revalidate',
      //       },
      //     };
      //     const response = await axios.post(`${BaseURL}/refresh`, null, axiosConfig);
      //     const newToken = response.data.authorisation.token;
      //     localStorage.setItem('token', newToken);

      //     error.config.headers.Authorization = `Bearer ${newToken}`;
      //     refreshAndRetryQueue.forEach(({ config, resolve, reject }) => {
      //       API.request(config)
      //         .then((response) => resolve(response))
      //         .catch((error) => reject(error));
      //     });
      //     refreshAndRetryQueue.length = 0;

      //     return API(originalRequest);
      //   } catch (refreshError) {
      //     // if refresh token get error send to login page
      //     if (refreshError.data && refreshError.data.response) {
      //       return Promise.reject(refreshError.data.response);
      //     }

      //     return <Navigate to={{ pathname: '/' }} />;
      //   } finally {
      //     isRefreshing = false;
      //   }
      // }

      // return new Promise((resolve, reject) => {
      //   refreshAndRetryQueue.push({ config: originalRequest, resolve, reject });
      // });

      GlobalData.token = null;
      GlobalData.userData = null;
      GlobalData.loginData = null;
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/';
      // return <Navigate to={{ pathname: '/' }} />;
    }
    return Promise.reject(error);
  }
);

export default API;
export { BaseURL };